import React from 'react';
import Loader from 'src/assets/images/LoadingAnimation.gif'; 
import { SpinnerContainer, ChildrenContainer, StyledImage, StyledImageContainer } from './Spinner.styled';

const Spinner = ({
    height = '100%', // Default height
    background = 'transparent', // Default background
    marginTop = '0', // Default margin-top
    children,
    small = false,
    id
}) => {
    return (
        <>
            <SpinnerContainer
                height={height}
                background={background}
                marginTop={marginTop}
                id={id}
            >
                <StyledImageContainer>
                    <StyledImage
                        className="loader-gif"
                        src={Loader}
                        alt="Loading Animation"
                        width={small ? '34px' : ''}
                        height={small ? '50px' : ''}
                    />
                </StyledImageContainer>
            </SpinnerContainer>
            <ChildrenContainer>
                {children}
            </ChildrenContainer>
        </>
    );
};

export default Spinner;
